/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacMatchState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_MATCH_STATE_ENTITY_NAME = 'ixf.watchlist.v1.OfacMatch';
export const ixfWatchlistV1OfacMatchStateEntity = new schema.Entity<IxfWatchlistV1OfacMatchState>(IXF_WATCHLIST_V1_OFAC_MATCH_STATE_ENTITY_NAME, {}, { idAttribute: 'ofacMatchId' });

